// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__sjfUA","loaderOuter":"PageOverlayLoader_loaderOuter__3UlHT"};